import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { SearchItemsArgs } from './types'

export const useSearch = () => {
  const router = useRouter()

  const addQueryParameter = useCallback(
    (keywords: string) => {
      router.replace({
        query: {
          ...router.query,
          search: keywords,
        },
      })
    },
    [router]
  )

  /**
   * If you specify a key that exists in rawData, the filter is executed for that key.
   */
  const searchItems = useCallback(<T>(args: SearchItemsArgs<T>) => {
    const { keywords, rawData, targetKeys } = args
    const lowerKeywords = keywords.toLowerCase()
    return rawData?.filter((v) => {
      if (!lowerKeywords) return true
      return targetKeys.some((key) => {
        const value = v[key] as string
        if (!value) return false
        return value.toLowerCase().includes(lowerKeywords)
      })
    })
  }, [])

  return { addQueryParameter, searchItems }
}
